<template>
    <v-card tile class="pa-0" hover height="100%">
        <v-card-text class="text-center">
            <apexchart type="bar" :height="height" :options="barOptions" :series="series" />
        </v-card-text>
    </v-card>
</template>

<script>
    import apexchart from 'vue-apexcharts'

    export default {

        components: {
            apexchart
        },

        props: ['title', 'height', 'series', 'categories', 'horizontal', 'distributed'],

        data() {
            return {
                barOptions: {
                    colors: ['#004D40', '#71bd48', '#01579B', '#006064', '#00796B', '#0097A7', '#0288D1', '#26A69A', '#26C6DA', '#29B6F6', '#4CAF50', '#66BB6A'],//this.generateColors(),
                    chart: {
                        type: 'bar',
                        fontFamily: 'Tajawal',
                        toolbar: {
                            show: true,
                        }
                    },
                    title: {
                        text: this.title,
                        align: 'center',
                        margin: 5,
                        offsetX: 0,
                        offsetY: 0,
                        floating: false,
                        style: {
                            fontSize: '11px',
                            fontWeight: 'bold',
                            fontFamily: undefined,
                            color: '#263238',
                            maxWidth: '200px'
                        }
                    },
                    plotOptions: {
                        bar: {
                            horizontal: false,//this.horizontal,
                            distributed: true//this.distributed
                            
                        },
                    },
                    dataLabels: {
                        enabled: true,
                        position: 'top',
                        style: {
                            colors: ['#fff']
                        },
                        dropShadow: {
                            enabled: true
                        }
                    },
                    stroke: {
                        show: false,
                        width: 2,
                    },

                    xaxis: {
                        categories: this.categories,
                        labels: {
                            labels: this.categories,
                            show: true,
                            rotate: 20,
                            rotateAlways: false,
                            maxHeight: 100,
                            style: {
                                fontSize: '10px',
                                fontFamily: 'Tajawal',
                                fontWeight: '600'
                            }
                        }
                    },
                    tooltip: {
                        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                            const labels = w.config.xaxis.labels.labels
                            if (seriesIndex !== 1 && labels && labels.length > dataPointIndex) {
                                const label = labels[dataPointIndex]
                                const value = series[seriesIndex][dataPointIndex]
                                return '<div style="padding:3px;font-weight:bold;color:white;background-color: #71BD48;">' + label + ': ' + value + '</div>'
                            }
                            return ''
                        }.bind(this)
                    },
                    fill: {
                        opacity: 1
                    },
                },

            }
        },
        methods: {
            generateColors() {
                const colors = ['#004D40', '#71bd48', '#01579B', '#006064', '#00796B', '#0097A7', '#0288D1', '#26A69A', '#26C6DA', '#29B6F6', '#4CAF50', '#66BB6A']
                const colorsBar = []
                console.log('fetit')
                const categories = this.categories || []
                const categoriesLength = categories.length
                for (let index = 0; index < categoriesLength; index++) {
                    colorsBar.push(colors[index])
                }
                this.colors = []
                this.colors = colorsBar
                return this.color
            }
        }
    }
</script>

<style>
    .apexcharts-legend-text {
        padding: 0 5px !important
    }

    .apexcharts-toolbar {
        top: -17px !important;
        right: -20px !important;
    }
</style>
